// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.boxx-btn {
  height: 13vw !important;
  min-height: 13vw !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/shared-components/lib/custom-location-picker/custom-location-picker.component.scss"],"names":[],"mappings":"AAKA;EACI,uBAAA;EACA,2BAAA;AAJJ","sourcesContent":["// .boxx-btn {\n//     height: 3vw !important;\n//     min-height: 3vw;\n// }\n\n.boxx-btn {\n    height: 13vw !important;\n    min-height: 13vw !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
